/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { ITreeNode } from "../../ui/components/Tree/TreeViewTypes";
import {
	Icon,
	ListItemIcon,
	ListItemText,
	MenuItem,
	MenuList,
	useClipboard
} from "@adapptio/lib-editor-ui";
import { isNonEmptyString, isString } from "@adapptio/lib-shared";

export interface IContextMenuScopeNodeProps {
	treeNode: ITreeNode;
}

export const ContextMenuScopeNode: React.FC<IContextMenuScopeNodeProps> = ({ treeNode }) => {
	const { copyToClipboard } = useClipboard();

	const metaData = treeNode.metaData;

	const itemKey = metaData?.key;
	const refData = metaData?.refData;
	const path = isNonEmptyString(metaData?.path) ? metaData.path : itemKey;

	if (!isString(itemKey)) {
		return null;
	}

	const handleCopyPath = useCallback(() => {
		copyToClipboard(path as string);
	}, [ path ]);

	const handleCopyValue = useCallback(() => {
		const refDataString = isString(refData) ? refData : JSON.stringify(refData);
		copyToClipboard(refDataString);
	}, [ refData ]);

	return (
		<MenuList>
			<MenuItem onClick={handleCopyPath}>
				<ListItemIcon>
					<Icon name="mdi/content-copy" />
				</ListItemIcon>
				<ListItemText align="left">Copy path</ListItemText>
			</MenuItem>
			<MenuItem onClick={handleCopyValue}>
				<ListItemIcon>
					<Icon name="mdi/content-copy" />
				</ListItemIcon>
				<ListItemText align="left">Copy value</ListItemText>
			</MenuItem>
		</MenuList>
	);
};
